import { render, staticRenderFns } from "./HotelRoomCard.vue?vue&type=template&id=0a1356ab&scoped=true&"
import script from "./HotelRoomCard.vue?vue&type=script&lang=js&"
export * from "./HotelRoomCard.vue?vue&type=script&lang=js&"
import style0 from "./HotelRoomCard.vue?vue&type=style&index=0&id=0a1356ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1356ab",
  null
  
)

export default component.exports